export default "__VITE_ASSET__52b46dae__"